import { NoticeBox } from '@factorialco/deprecated-design-system'
import {
  EmployeeRootPageEmployeeFragment,
  EmployeeRootPageEmployeeReferenceContractFragment,
} from 'generated/resources/graphql'
import moment from 'moment'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Props {
  employee: EmployeeRootPageEmployeeFragment & EmployeeRootPageEmployeeReferenceContractFragment
  canTerminateEmployee: boolean
}

const TerminationBanner = ({ employee, canTerminateEmployee }: Props) => {
  if (!employee.terminatedOn || !canTerminateEmployee) {
    return null
  }

  const now = moment()
  const accessEndDate = stringToDate(employee.terminatedOn, 'backend')
  const isAccessPast = accessEndDate.isSameOrBefore(now, 'day')

  const contractEndDate = employee.referenceContract?.endsOn
  const contractDate = contractEndDate ? stringToDate(contractEndDate, 'backend') : null
  const isContractPast = contractDate ? contractDate.isSameOrBefore(now, 'day') : false

  // Format dates for display
  const accessDateFormatted = i18nDateToString(accessEndDate, 'ui')
  const contractDateFormatted = contractDate ? i18nDateToString(contractDate, 'ui') : ''

  // Determine which message to use based on the logic
  let message: string

  if (!contractDate) {
    // Only access end date exists
    if (isAccessPast) {
      message = i18n.t('employees.termination_banner.access_past', { date: accessDateFormatted })
    } else {
      message = i18n.t('employees.termination_banner.access_future', { date: accessDateFormatted })
    }
  } else if (accessEndDate.isSame(contractDate, 'day')) {
    // Both dates exist and are the same
    if (isAccessPast) {
      message = i18n.t('employees.termination_banner.agreement_access_same_past', {
        date: accessDateFormatted,
      })
    } else {
      message = i18n.t('employees.termination_banner.agreement_access_same_future', {
        date: accessDateFormatted,
      })
    }
  } else {
    // Both dates exist and are different
    if (isContractPast && isAccessPast) {
      message = i18n.t('employees.termination_banner.agreement_past_access_past', {
        agreement_date: contractDateFormatted,
        access_date: accessDateFormatted,
      })
    } else if (!isContractPast && !isAccessPast) {
      message = i18n.t('employees.termination_banner.agreement_future_access_future', {
        agreement_date: contractDateFormatted,
        access_date: accessDateFormatted,
      })
    } else if (!isContractPast && isAccessPast) {
      message = i18n.t('employees.termination_banner.agreement_future_access_past', {
        agreement_date: contractDateFormatted,
        access_date: accessDateFormatted,
      })
    } else {
      message = i18n.t('employees.termination_banner.agreement_past_access_future', {
        agreement_date: contractDateFormatted,
        access_date: accessDateFormatted,
      })
    }
  }

  return <NoticeBox message={message} justifyContent="center" />
}

export default TerminationBanner
